import type { Block } from './types'
import type { BlockAction } from './BlockActionsMenu'
import { HeadingBlockView } from './HeadingBlock'
import { ParagraphBlockView } from './ParagraphBlock'
import { BulletListBlockView } from './BulletListBlock'
import { CalloutBlockView } from './CalloutBlock'
import { AllocationComparisonBlockView } from './AllocationComparisonBlock'
import { MaturityTimelineBlockView } from './MaturityTimelineBlock'
import { FundListBlockView } from './FundListBlock'

export interface BlockRendererProps {
  block: Block
  selected: boolean
  frozen: boolean
  animate: boolean
  actions: BlockAction[]
  onTextChange: (id: string, text: string) => void
  onToggleSelect: (id: string) => void
}

export function BlockRenderer(props: BlockRendererProps) {
  const { block } = props
  switch (block.type) {
    case 'heading':
      return <HeadingBlockView {...props} block={block} />
    case 'paragraph':
      return <ParagraphBlockView {...props} block={block} />
    case 'callout':
      return <CalloutBlockView {...props} block={block} />
    case 'bulletList':
      return <BulletListBlockView {...props} block={block} />
    case 'fundList':
      return <FundListBlockView {...props} block={block} />
    case 'allocationComparison':
      return <AllocationComparisonBlockView {...props} block={block} />
    case 'maturityTimeline':
      return <MaturityTimelineBlockView {...props} block={block} />
  }
}
